import { ActionTypes } from "@/App/constants/actionTypes";
import { TransmissionTypes } from "@/types";
import { NavigateFunction } from "react-router";

type UploadTestClaimBatchAction = {
  type: typeof ActionTypes.UPLOAD_BATCH_TRANSMISSION_TEST_CLAIM_BATCH;
  payload: TransmissionTypes.TestClaimBatchUploadFile;
  formName: string;
  navigate: NavigateFunction;
};

export const uploadTestClaimBatch = (data: TransmissionTypes.TestClaimBatchUploadFile, formName: string, navigate: NavigateFunction): UploadTestClaimBatchAction => {
  return {
    type: ActionTypes.UPLOAD_BATCH_TRANSMISSION_TEST_CLAIM_BATCH,
    payload: data,
    formName,
    navigate,
  };
};

export type TestClaimBatchActions = UploadTestClaimBatchAction;
